import React from "react";
import Rapidoc from "./Components/Rapidoc";
const App = () => {
  return (
    <Rapidoc />
  );
};

export default App;
